export const API_URL = 'https://my-happythoughts-api.herokuapp.com/thoughts'
export const LIKES_URL = (messageID) => `https://my-happythoughts-api.herokuapp.com/thoughts/${messageID}/likes`
